import { CLOSE_NOTIFICATION, SHOW_NOTIFICATION } from "redux/actions/notificationAction";

// notificationReducer.ts
interface NotificationState {
  alertMessage: {
    open: boolean;
    content: string;
    severity: "success" | "error" | "warning" | "info";
    countDown?: number;
  };
}

const initialState: NotificationState = {
  alertMessage: {
    open: false,
    content: "",
    severity: "info",
  },
};

export const notificationReducer = (state = initialState, action: any): NotificationState => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        alertMessage: {
          open: true,
          content: action.payload.content,
          severity: action.payload.severity,
          countDown: action.payload.countDown,
        },
      };
    case CLOSE_NOTIFICATION:
      return {
        alertMessage: {
          ...state.alertMessage,
          open: false,
        },
      };
    default:
      return state;
  }
};
